<template>
  <v-card
      color="grey"
      class="ma-4 pa-10 lighten-3"
      flat
  >
    <v-card-title>
      Sorry, this content is not available right now.
    </v-card-title>

    <v-divider />

    <v-card-subtitle>
      It may have been expired or deleted.  If you think something is broken,

      <a href="mailto:enquiries@learningplus.co.uk">
        report this problem.
      </a>
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: "UnavailableContent",
};
</script>